import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { _Api } from '../api/_call';
import { error, loading, Updateloading } from "../common/helpers/toastify";
import { createreserveinventoryhead } from '../common/Tablehead';
import { Saleperson, VoucherList } from "../common/graphql/commonlayouts";
import CustomerSearchModal from "../common/modules/customerSearch";
import CustomerSearchDetailModal from "../common/modules/CustomerSearchDetailModal";
import TransAndDeliverDate from "../common/modules/TransAndDeliverDate";
import { reserveDuedate } from "../common/helpers/formatDate";
import ConfirmationModel from "../common/modules/confirmationmodel";
import ProductModal from "../common/modules/ProductModal";
import { toFormatPrice } from "../common/helpers/function";
import { useTranslation } from 'react-i18next';
import CustomerInformation from "../../admin/customers/customerInformation/CustomerInformation";
import TableLoader from "../../admin/common/TableLoader";
import { useSelector } from "react-redux";

// Column order mirrors createreserveinventoryhead — index-aligned so a
// column's sort key can be looked up by its position.
const SORT_KEYS = [
  null, null, "name", "sku", "stock_id", "price", "location", "qty", "remark",
];
const SORT_ACCESSORS = {
  name: (r) => r?.name,
  sku: (r) => r?.SKU,
  stock_id: (r) => r?.stock_id,
  price: (r) => Number(r?.retailprice_Inc) || 0,
  location: (r) => r?.location_name,
  qty: (r) => Number(r?.po_QTY) || 0,
  remark: (r) => r?.remark,
};

const getUnavailableReason = (unavailable, row) =>
  (unavailable || []).find(
    (item) => item?.po_product_id === row?.id || item?.stock_id === row?.stock_id
  )?.reason;

const CreateReserve = (props) => {
  const { t } = useTranslation();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [getoneproduct, setOneproduct] = useState();
  const [deliveryDate, set_deliveryDate] = useState();
  const [transactionDate, set_transactionDate] = useState(new Date());
  const [commanSelected_sal, setcommanSelected_sal] = useState();
  const [commanSelected_vouc, setcommanSelected_vouc] = useState();
  const [cusid, setCusid] = useState();
  const [SelectAllStatus, setSelectAllStatus] = useState();
  const [selecteditem, setSelecteditem] = useState([]);
  const [openRemarkSuggestion, setOpenRemarkSuggestion] = useState(null);
  const [ShowSubmitbutton, setShowSubmitbutton] = useState(true);
  const [customerid, setCustomerid] = useState();
  const [reservelist, setReservelist] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [newcustomersid, setnewcustomersid] = useState();
  const [oldreservelist, setOldreservelist] = useState();
  const [, setCreatecustomer] = useState(false)
  const [datalodaer, setDatsLodaer] = useState(false)
  const [orderRef, setOrderRef] = useState("")
  const [unavailableItems, setUnavailableItems] = useState([])
  const navigate = useNavigate();
  const { state } = useLocation();
  const [kycIntegrate, setKycIntegrate] = useState();

  const getdeliverydate = async () => {
    set_deliveryDate(await reserveDuedate(new Date()));
  }
  useEffect(() => {
    getdeliverydate();
  }, []);
  const GetReservelist = async () => {
    setDatsLodaer(true)
    try {
      const postdata = {
        "ids": state?.datalist ? state?.datalist : []
      };
      let res = await _Api(postdata, `api/v1/Inventory/my/getCreateReservelist`);
      if (res?.code === 200) {
        const list = Array.isArray(res?.data) ? res.data : [];
        setReservelist(list);
        setOldreservelist(list);
        setUnavailableItems([]);
      } else {
        setReservelist([]);
        setOldreservelist([]);
        if (res?.errors || res?.message) {
          error(res?.errors || res?.message);
        }
      }
    }
    catch (err) {
      console.log(err, 'err');
    }
    finally {
      setDatsLodaer(false)
    }
  }
  // Custom client-side sorting (replaces jQuery DataTables sorting).
  const handleSort = (key) => {
    setSortConfig((prev) =>
      prev.key === key
        ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key, direction: "asc" }
    );
  };
  const sortedList = useMemo(() => {
    const accessor = SORT_ACCESSORS[sortConfig.key];
    if (!accessor) return reservelist;
    const sorted = [...reservelist].sort((a, b) => {
      const av = accessor(a);
      const bv = accessor(b);
      if (av === undefined || av === null) return 1;
      if (bv === undefined || bv === null) return -1;
      if (typeof av === "number" && typeof bv === "number") return av - bv;
      return String(av).localeCompare(String(bv), undefined, { numeric: true });
    });
    return sortConfig.direction === "asc" ? sorted : sorted.reverse();
  }, [reservelist, sortConfig]);
  const submit = async () => {
    const handleValidation = (e) => {
      let formIsValid = true;
      if (!deliveryDate) {
        formIsValid = false;
        error(t("DeliveryDate is Requried!"));
        return;
      }
      if (!transactionDate) {
        formIsValid = false;
        error(t("TransactionDate is Requried!"));
        return;
      }
      if (!commanSelected_sal) {
        formIsValid = false;
        error(t("SalePerson is Requried!"));
        return;
      }
      if (!commanSelected_vouc) {
        formIsValid = false;
        error(t("Choose Voucher!"));
        return;
      }
      if (!customerid) {
        formIsValid = false;
        error(t("Customer is required."));
        return;
      }
      var allcheck = document.querySelectorAll(".createreserveinventory");
      for (var j = 0; j < allcheck.length; j++) {
        let qty = allcheck[j].getAttribute('data-qty');
        if (parseInt(qty) === 0) {
          let qtycheck = document.querySelectorAll(".reserveqty");
          qtycheck[j].style.border = "1px solid red ";
          formIsValid = false;
        } else {
          let qtycheck = document.querySelectorAll(".reserveqty");
          qtycheck[j].style.border = "1px solid #f4f4f4 ";
        }
      }
      return formIsValid;
    };
    if (handleValidation()) {
      let details = [];
      let reservedata = [];
      var allcheck = document.querySelectorAll(".createreserveinventory");
      for (let i = 0; i < allcheck.length; i++) {
        if (allcheck[i].checked) {
          reservelist.forEach((result) => {
            if (result.id === allcheck[i]?.id) {
              details.push(result);
            }
          });
        }
      }
      for (var keys = 0; keys < details.length; keys++) {
        reservedata.push({
          "stock_id": details[keys]?.stock_id,
          "reserve_qty": parseInt(details[keys]?.po_QTY),
          "po_product_id": details[keys]?.id,
          "remark": details[keys]?.remark || ""
        });
      }
      if (!reservedata?.length) {
        error(t("No item Selected!!"));
        return;
      }
      setUnavailableItems([]);
      setShowSubmitbutton(false);
      let GetloadingID = loading();
      try {
        const postdata = {
          "customer_id": customerid,
          "ref_no": orderRef || "",
          delivery_date: deliveryDate,
          transaction_date: transactionDate,
          "sales_person_id": commanSelected_sal,
          "voucher_id": commanSelected_vouc,
          "reservedItems": reservedata,
        };
        if (state?.crosslocation && state?.crossLocationId) {
          postdata.crosslocation = true;
          postdata.crossLocationId = state.crossLocationId;
        }
        let res = await _Api(postdata, `api/v1/Inventory/my/createReserveOrder`);
        setShowSubmitbutton(true);
        if (res?.code === 200) {
          const orderNo = res?.data?.order_no || "";
          if (orderNo) {
            setOrderRef(orderNo);
          }
          const successText = orderNo
            ? `${res?.message || t("Reserve created successfully")} (${orderNo})`
            : (res?.message || t("Reserve created successfully"));
          Updateloading(t, GetloadingID, successText);
          setTimeout(() => {
            navigate("/app/inventory/reserveList");
          }, 500);
        } else if (res?.code === 400) {
          if (Array.isArray(res?.unavailable) && res.unavailable.length) {
            setUnavailableItems(res.unavailable);
            Updateloading(t, GetloadingID, res?.message || t("Some items are not available to reserve"), "error");
            res.unavailable.forEach((item) => {
              error(`${item?.stock_id || item?.po_product_id}: ${item?.reason}`);
            });
          } else {
            Updateloading(
              t,
              GetloadingID,
              res?.errors || res?.message || t("Something Went Wrong!!"),
              "error"
            );
          }
        } else {
          const failMessage = res?.message || t("Something Went Wrong!!");
          Updateloading(t, GetloadingID, failMessage, "error");
          if (typeof failMessage === "string" && failMessage.startsWith("Stock no longer available")) {
            GetReservelist();
          }
        }
      }
      catch (err) {
        setShowSubmitbutton(true);
        Updateloading(t, GetloadingID, err?.message || t("Something Went Wrong!!"), "error");
        console.log(err, 'err');
      }
    }
  }
  const deleteProduct = () => {
    const selected = document.querySelectorAll(".createreserveinventory");
    for (let i = 0; i < selected.length; i++) {
      if (selected[i].checked) {
        let product_id = selected[i].getAttribute('data-id');
        setReservelist((current) =>
          current.filter((item) => item?.id !== product_id)
        );
        selected[i].checked = false;
      }
    }
    setSelecteditem([]);
  }
  const handleSelectAllCheckBox = (event) => {
    const isChecked = event.target.checked;
    document.querySelectorAll(".createreserveinventory").forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
    setSelectAllStatus(isChecked);
  };
  const selectedproduct = (event) => {
    if (event.target.checked) {
      const mainselected = [...selecteditem, event.target.value];
      setSelecteditem(mainselected);
    } else {
      const result = selecteditem.filter((element) => {
        return element !== event.target.value;
      });
      setSelecteditem(result);
    }
  }
  const changeqty = (event, id) => {
    const i = reservelist.findIndex((item) => item?.id === id);
    if (i === -1) return;
    var main = [...reservelist];
    let oldmain = [...oldreservelist];
    if (event.target.value <= oldmain[i].po_QTY) {
      const { value, name } = event.target;
      main[i] = {
        ...main[i],
        [name]: value,
      };
      setReservelist(main);
    } else {
      error(t("Enter Quantity less than") + oldmain[i].po_QTY);
    }
  };
  const changeremark = (event, id) => {
    const i = reservelist.findIndex((item) => item?.id === id);
    if (i === -1) return;
    var main = [...reservelist];
    main[i] = {
      ...main[i],
      remark: event.target.value,
    };
    setReservelist(main);
  }

  const getTomorrowPickupLabel = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const datePart = tomorrow.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    return `Pickup on ${datePart}, 2:00 PM`;
  };

  const remarkSuggestions = [
    getTomorrowPickupLabel(),
    t("On hold until closing time"),
    t("Customer response"),
    t("Payment verification"),
  ];

  const selectRemarkSuggestion = (id, suggestion) => {
    const i = reservelist.findIndex((item) => item?.id === id);
    if (i === -1) return;
    const main = [...reservelist];
    main[i] = {
      ...main[i],
      remark: suggestion,
    };
    setReservelist(main);
    setOpenRemarkSuggestion(null);
  };

  useEffect(() => {
    if (SelectAllStatus) {
      const selected = document.querySelectorAll(".createreserveinventory");
      let arrya = [];
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].checked) {
          let product_id = selected[i].getAttribute('data-id');
          arrya.push(product_id);
        }
      }
      setSelecteditem(arrya);
    } else {
      setSelecteditem([]);
    }
  }, [SelectAllStatus]);

  useEffect(() => {
    if (state?.datalist) {
      GetReservelist();
    }
    // eslint-disable-next-line
  }, []);


  useEffect(() => { }, [deliveryDate]);
  return (
    <>
      <div className="main-body createreserve">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">

              <div className="top-heading-area">
                <div className="top-heading-area-left">
                  <div onClick={() => navigate(-1)} className="page-back-btn">
                    <img
                      src={base_assets + "images/icons/arrow-left.png"}
                      alt=""
                    />
                  </div>
                  <img src={base_assets + "images/icons/home-icon.png"} alt="" />
                  <VoucherList
                    setcommanSelected_vouc={setcommanSelected_vouc}
                    group={"Inventory_Reserve"}
                  ></VoucherList>
                </div>
                <h1 className="main-heading text-center">{t("Create Reserve")}</h1>
              </div>

              <div className="main-body-top-inputs-bar top-bar-input">
                <div className="main-body-top-inputs-bar-col-left">
                  <label className="po-num-label  po-num-red">{orderRef || t("REF-XXX")}</label>
                  <CustomerSearchModal setSearchid={setCustomerid} newcustomer={newcustomersid} setCreatecustomer={setCreatecustomer} kycIntegrate={kycIntegrate} setKycIntegrate={setKycIntegrate}></CustomerSearchModal>
                  {parmissiondatashow?.pos_customer_reports?.Add ?
                    <button className="btn-user" data-bs-toggle="modal" data-bs-target="#customerAddModal"
                      onClick={() => (setCreatecustomer(true))}>
                      <img className="" src={base_assets + "images/pos/icons/add-user.png"} alt="" />
                    </button>
                    :
                    ""}
                  <Saleperson
                    setcommanSelected_sal={setcommanSelected_sal}
                  />
                  <TransAndDeliverDate TransactionDate={transactionDate} DeliveryDate={deliveryDate} setTransactionDate={set_transactionDate} setDeliveryDate={set_deliveryDate} />
                </div>
                <div className="main-body-top-inputs-bar-col-right">
                  <button className={
                    selecteditem.length > 0
                      ? "deletebtn btn-style d-block"
                      : "d-none"
                  } onClick={deleteProduct}>
                    <img src={base_assets + "images/icons/delete-icon.png"} alt="" />
                  </button>
                  <button
                    className={
                      ShowSubmitbutton
                        ? "main-body-top-inputs-bar-col-right-submit-btn com-btn "
                        : "main-body-top-inputs-bar-col-right-submit-btn com-btn d-block  deactive"
                    }
                    data-bs-toggle="modal"
                    data-bs-target="#createPurchaseModal"
                  >
                    {t("Submit")}
                  </button>
                </div>
              </div>
              <div className="common-sub-table-wrap add-row">
                <div className="main-body-main-table-wrap">
                  <table id="create_reserve_table" className="common-table product-base-table w-100">
                    <thead>
                      <tr>
                        {createreserveinventoryhead?.map((col, index) => {
                          if (col.name === "check_box") {
                            return (
                              <th key={index}>
                                <div className="com-check">
                                  <input
                                    id="th_comman_checkbox"
                                    onClick={handleSelectAllCheckBox}
                                    className={col.class}
                                    type="checkbox"
                                  />
                                  <label
                                    htmlFor="th_comman_checkbox"
                                    className="com-check-label"
                                  />
                                </div>
                              </th>
                            );
                          }
                          const sortKey = SORT_KEYS[index];
                          const active = sortConfig.key === sortKey;
                          return (
                            <th
                              key={index}
                              className={col.class}
                              onClick={sortKey ? () => handleSort(sortKey) : undefined}
                              style={sortKey ? { cursor: "pointer" } : undefined}
                            >
                              {t(col.lable)}
                              {sortKey ? (
                                <div className="up-down-arrow-btn">
                                  <img
                                    className={
                                      "up-down-arrow-img up-down-arrow-img-forward" +
                                      (active && sortConfig.direction === "desc" ? "" : " active")
                                    }
                                    src={base_assets + "images/icons/up-down-arrow.png"}
                                    alt=""
                                  />
                                  <img
                                    className={
                                      "up-down-arrow-img up-down-arrow-img-reverse" +
                                      (active && sortConfig.direction === "desc" ? " active" : "")
                                    }
                                    src={base_assets + "images/icons/up-down-arrow-reverse.png"}
                                    alt=""
                                  />
                                </div>
                              ) : null}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {sortedList?.length ? sortedList.map((result, key) => {
                          const unavailableReason = getUnavailableReason(unavailableItems, result);
                          return (
                            <tr key={result?.id || key}>
                              <td>
                                <div className="com-check">
                                  <input id={result?.id} data-id={result?.id} data-qty={result?.po_QTY} onChange={selectedproduct} type="checkbox" className="createreserveinventory" />
                                  <label htmlFor={result?.id} className="com-check-label" />
                                </div>
                              </td>
                              <td className="sku-col">{key + 1}</td>
                              <td>
                                <div className="tooltip-area-up">
                                  <span className="table-pro-tooltip">{result?.name ? result?.name : ''}</span>
                                  <span className="tooltip-area-up-text text-white">
                                    {result?.name ? result?.name : ''}
                                  </span>
                                </div>
                              </td>
                              <td className="link-color" onClick={() => { setOneproduct(result) }} data-bs-toggle="modal" data-bs-target="#ProductInfoModal"> {result?.SKU ? result?.SKU : ''}</td>
                              <td className="po-no">{result?.stock_id ? result?.stock_id : ''}</td>
                              <td>
                                {toFormatPrice(result?.retailprice_Inc, { addSymbol: true },result?.loccurr)}</td>
                              <td>{result?.location_name ? result?.location_name : ''}</td>
                              <td>
                                      <div className="col-input input-field-bg">
                                        <input
                                          type="text"
                                          className="reserveqty"
                                          id="qtycheck"
                                          name="po_QTY"
                                          value={result?.po_QTY}
                                          onChange={(e) => changeqty(e, result?.id)}
                                          style={unavailableReason ? { border: "1px solid red" } : undefined}
                                        />
                                      </div>
                                      {unavailableReason ? (
                                        <span className="text-danger d-block mt-1">{unavailableReason}</span>
                                      ) : null}
                              </td>
                              <td className="createreserve-remark-cell">
                                <div className="createreserve-remark col-input input-field-bg">
                                  <input
                                    type="text"
                                    value={result?.remark || ""}
                                    onChange={(e) => changeremark(e, result?.id)}
                                    onFocus={() => setOpenRemarkSuggestion(result?.id)}
                                    onBlur={() => setOpenRemarkSuggestion(null)}
                                    name="reserve_remark"
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    spellCheck={false}
                                    placeholder={t("Remark")}
                                    aria-label={t("Remark")}
                                  />
                                  {openRemarkSuggestion === result?.id ? (
                                    <div className="createreserve-remark-suggestion">
                                      <span className="createreserve-remark-suggestion-title">
                                        {t("Suggestion")}
                                      </span>
                                      {remarkSuggestions.map((suggestion, sIndex) => (
                                        <span
                                          key={sIndex}
                                          className="createreserve-remark-suggestion-item"
                                          onMouseDown={(e) => e.preventDefault()}
                                          onClick={() => selectRemarkSuggestion(result?.id, suggestion)}
                                        >
                                          {suggestion}
                                        </span>
                                      ))}
                                    </div>
                                  ) : null}
                                </div>
                              </td>
                            </tr>
                          );
                        }) : !datalodaer && (
                          <tr className="bg-white">
                            <td colSpan={createreserveinventoryhead.length} className="text-center bg-white">
                              {t("No Data Available")}
                            </td>
                          </tr>
                        )}
                      </>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="3" className="main-green-text left-0 text-start">
                          {selecteditem.length > 0 ? (
                            <span> {selecteditem.length} {t("item Selected")}</span>
                          ) : (
                            ""
                          )}
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>{reservelist?.reduce(
                          (interation, val) => (interation = interation + parseInt(val.po_QTY ? val.po_QTY : 0)),
                          0
                        )}</td>
                        <td />
                      </tr>
                    </tfoot>
                  </table>
                  {datalodaer && <TableLoader />}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ProductModal data_product={getoneproduct} setOneproduct={setOneproduct} editproduct_submit={''} />
        <CustomerInformation
          cusid={cusid}
          setCusid={setCusid}
        />
        <ConfirmationModel
          handler_submit={submit}
          statement={"Reserved this lists"}
          handler_dismiss={GetReservelist}
        ></ConfirmationModel>
        <CustomerSearchDetailModal setnewcustomersid={setnewcustomersid} newcustomersid={newcustomersid} setCusid={setCusid} onKycIntegrate={setKycIntegrate} />
      </div>
    </>
  );
}

export default CreateReserve;